import request from '@/services/interceptor.js'

// Calendario unificato (Manutenzioni + Scadenze mezzo + Pagamenti), sostituisce
// il vecchio /api/manutenzione/calendario. I filtri macchinaId/mezzoId/tipoPagamentoId
// sono supportati dal backend ma il frontend (Calendario.vue) scarica sempre
// l'intervallo di date completo e filtra client-side, per non generare un
// nuovo fetch a ogni cambio di filtro (vedi Calendario.vue).
export const get_eventi_calendario = (dataInizio, dataFine, macchinaId, mezzoId, tipoPagamentoId) => {
    return request({
        url: '/calendario',
        method: 'get',
        params: { dataInizio, dataFine, macchinaId, mezzoId, tipoPagamentoId },
        loadingBar: true
    })
}
